// Admins who are also superusers (same rule as the back's HasSuperAdminRole).
export default function auth({ next }) {
  const session = localStorage.getItem('session') || sessionStorage.getItem('session')
  if (!session) {
    return next({ name: 'auth-login' })
  }
  const { user } = JSON.parse(session)
  if (!user || user.role !== 0 || !user.is_superuser) {
    return next({ name: 'evaluations' })
  }

  return next()
}
